const root = 'ProductSlate'
const productCost = `${root}-productCost`
const retailPrice = `${root}-retailPrice`

export const TestId = {
  root,
  inventoryType: `${root}-inventoryType`,
  brandName: `${root}-brandName`,
  productImage: `${root}-productImage`,
  productName: `${root}-productName`,
  productQuantity: `${root}-productQuantity`,
  productCost,
  productCostMin: `${productCost}-min`,
  productCostMax: `${productCost}-max`,
  retailPrice,
  retailPriceMin: `${retailPrice}-min`,
  retailPriceMax: `${retailPrice}-max`,
  addProductActionButton: `${root}-addProductActionButton`,
  viewDetailsActionButton: `${root}-viewDetailsActionButton`,
  importedBadge: `${root}-importedBadge`,
}
